module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("“The Battle of France is over. I expect that the Battle of Britain is about to begin. Upon this battle depends the survival of Christian civilization. Upon it depends our own British life, and the long continuity of our institutions and our Empire. The whole fury and might of the enemy must very soon be turned on us. Hitler knows that he will have to break us in this island or lose the war. If we can stand up to him, all Europe may be freed and the life of the world may move forward into broad, sunlit uplands. But if we fail, then the whole world, including the United States, including all that we have known and cared for, will sink into the abyss of a new dark age made more sinister, and perhaps more protracted, by the lights of perverted science. Let us therefore brace ourselves to our duties, and so bear ourselves, that if the British Empire and its Commonwealth last for a thousand years, men will still say, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This was their finest hour")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-right"
  }, [_vm._v("—Winston Churchill’s speech to the House of Commons of the Parliament of the United Kingdom on 18 June 1940")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a20ced54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm.vue
// module id = 69
// module chunks = 0